export default __webpack_public_path__ + "locales/sk/VersionHistory.json?hash=f92b50a648f06ca529d6693b4e7a637f";